// Libraries
import { Flex } from '@chakra-ui/react';
// Components
import { excludedFilters } from '@organisms/index';
import { PillGroup } from './Components';
// Types
import { PillListProps } from './PillList.types';

/**
 * PillList component to display a list of pill groups based on the table column filters.
 *
 * @component
 * @template TableBody - The type of data for the table body.
 * @param {PillListProps} props - The props for the PillList component.
 * @returns {ReactElement} - The JSX element representing the PillList component.
 */
export const PillList = ({ setColumnFilters, columnFilters }: PillListProps) => {
  const filters = columnFilters.filter((filter) => !excludedFilters.includes(filter.id));

  return (
    <Flex gap={2} flexWrap='wrap' p={4} display={{ base: 'none', md: 'flex' }}>
      {filters.map((filterGroup) => (
        <PillGroup filterGroup={filterGroup} key={`${filterGroup.id}-group`} setColumnFilters={setColumnFilters} />
      ))}
    </Flex>
  );
};
